import React, { useState } from 'react';
import ImageViewer from './ImageViewer';

const PAGE_SIZE = 20;

const AWSGallery = ({ galleryData }) => {
  const [page, setPage] = useState(1);
  const [viewerIndex, setViewerIndex] = useState(null);

  if (!galleryData) {
    return <p>Loading gallery...</p>;
  }

  const totalPages = Math.ceil(galleryData.length / PAGE_SIZE);
  const start = (page - 1) * PAGE_SIZE;
  const pageItems = galleryData.slice(start, start + PAGE_SIZE);

  const openViewer = (localIndex) => setViewerIndex(start + localIndex);
  const closeViewer = () => setViewerIndex(null);
  const prevImage = () => setViewerIndex(i => Math.max(0, i - 1));
  const nextImage = () => setViewerIndex(i => Math.min(galleryData.length - 1, i + 1));

  return (
    <div>
      <div className="gallery">
        {pageItems.map((photo, index) => {
          const linkObj = Array.isArray(photo.link) ? photo.link[0] : photo.link;
          const photoLink = linkObj?.thumbnail_url || linkObj?.uri;
          return (
            <div
              key={start + index}
              className="gallery-item"
              onClick={() => openViewer(index)}
              style={{ cursor: 'pointer' }}
            >
              {photoLink ? (
                <img
                  src={photoLink}
                  alt={linkObj?.title || `Image ${start + index + 1}`}
                  loading="lazy"
                  decoding="async"
                />
              ) : (
                <p>No image available</p>
              )}
              <p>{linkObj?.title || `Image ${start + index + 1}`}</p>
            </div>
          );
        })}
      </div>

      {totalPages > 1 && (
        <div className="gallery-pagination">
          <button
            className="gallery-page-btn"
            onClick={() => setPage(p => Math.max(1, p - 1))}
            disabled={page === 1}
          >
            ‹ Prev
          </button>

          {Array.from({ length: totalPages }, (_, i) => i + 1)
            .filter(p => p === 1 || p === totalPages || Math.abs(p - page) <= 2)
            .reduce((acc, p, idx, arr) => {
              if (idx > 0 && p - arr[idx - 1] > 1) acc.push('...');
              acc.push(p);
              return acc;
            }, [])
            .map((item, i) =>
              item === '...' ? (
                <span key={`ellipsis-${i}`} className="gallery-page-ellipsis">…</span>
              ) : (
                <button
                  key={item}
                  className={`gallery-page-btn${page === item ? ' gallery-page-btn--active' : ''}`}
                  onClick={() => setPage(item)}
                >
                  {item}
                </button>
              )
            )}

          <button
            className="gallery-page-btn"
            onClick={() => setPage(p => Math.min(totalPages, p + 1))}
            disabled={page === totalPages}
          >
            Next ›
          </button>
        </div>
      )}

      {viewerIndex !== null && (
        <ImageViewer
          images={galleryData}
          currentIndex={viewerIndex}
          onClose={closeViewer}
          onPrev={prevImage}
          onNext={nextImage}
        />
      )}
    </div>
  );
};

export default AWSGallery;
